/**
 * Home Page
 * 6개 운세 서비스 선택 화면
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { tokens } from '../../design-system/tokens';
import { FortuneServiceCard } from '../../components/molecules/FortuneServiceCard';
import cloverImg from '../../assets/6002cc6e75d95c1d74ff91abadefd0ed9f9ca634.png';
import calendarImg from '../../assets/13a44ddde7bbcd12f6c4ad49848c5ecdbd0c1afd.png';
import heartImg from '../../assets/5536b38b2e4c3639914ade9678b968db458e7116.png';
import flowerImg from '../../assets/fe742ae1dd4747cc2854c5d0189f0053a9c90747.png';
import goldImg from '../../assets/574ea26519541404f65e73f895ac7b0628722845.png';
import sunImg from '../../assets/f91bf7f4e37f21063f53872048d7d211187b53d3.png';

interface ServiceItem {
  id: string;
  title: string;
  description: string;
  image: string;
  imageHeight: number;
  path: string;
}

const services: ServiceItem[] = [
  {
    id: 'today',
    title: '오늘의 운세',
    description: '오늘은 어떤 기운이 따를까요?\n오늘 하루를 바꿀 작은 행운',
    image: cloverImg,
    imageHeight: 110,
    path: '/fortune/today'
  },
  {
    id: 'saju',
    title: '사주팔자',
    description: '사주로 보는 내 삶의 설계도,\n태어난 순간이 말해주는 내 인생의 길',
    image: calendarImg,
    imageHeight: 102,
    path: '/fortune/saju'
  },
  {
    id: 'compatibility',
    title: '궁합',
    description: '우린 정말 잘 맞을까? \n궁합으로 알아보는 우리 사이',
    image: heartImg,
    imageHeight: 95,
    path: '/fortune/compatibility'
  },
  {
    id: 'love',
    title: '연애운',
    description: '내 사랑은 언제 찾아올까?\n연애운으로 알아보는 인연의 시작',
    image: flowerImg,
    imageHeight: 115,
    path: '/fortune/love'
  },
  {
    id: 'wealth',
    title: '재물운',
    description: '재물이 들어올 타이밍,\n부를 부르는 기운을 확인하세요',
    image: goldImg,
    imageHeight: 95,
    path: '/fortune/wealth'
  },
  {
    id: 'tojung',
    title: '토정비결',
    description: '다가오는 한 해의 시작, \n럭키온 토정비결로 걱정 끝 ',
    image: sunImg,
    imageHeight: 110,
    path: '/fortune/tojung'
  }
];

export const HomePage: React.FC = () => {
  const navigate = useNavigate();

  const handleServiceClick = (path: string) => {
    navigate(path);
  };

  return (
    <ServiceList>
      {services.map((service) => (
        <FortuneServiceCard
          key={service.id}
          title={service.title}
          description={service.description}
          image={service.image}
          imageHeight={service.imageHeight}
          onClick={() => handleServiceClick(service.path)}
        />
      ))}
    </ServiceList>
  );
};

const ServiceList = styled.div`
  padding: ${tokens.spacing[8]} ${tokens.spacing[8]};
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing[5]};

  @media (max-width: ${tokens.breakpoints.md}) {
    padding: ${tokens.spacing[5]} ${tokens.spacing[4]};
    gap: ${tokens.spacing[4]};
  }
`;